export const emptyAddress = {
  street1: '',
  street2: '',
  city: '',
  zipCode: '',
  state: '',
}
